<template>
  <div class="teacher-statistics">
    <div class="tuolele-main-box">
      <div class="form-row">
        <div class="form-input fn-clear">
          <span class="fn-left">选择店铺</span>
          <el-select v-model="filterObj.shop_id" placeholder="请选择">
            <el-option label="全部" value="0" />
            <el-option
              v-for="item in shopList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div>
      </div>
      <div class="form-row">
        <div class="form-input fn-clear">
          <span class="fn-left">选择时间</span>
          <el-date-picker
            v-model="filterObj.begin_time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
          />
          <i>至</i>
          <el-date-picker
            v-model="filterObj.end_time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
          />
          <div
            class="calendar-btn"
            :class="{ active: filterObj.search_calendar == 1 }"
            @click="changeCalendar"
          >
            只看工作日
          </div>
          <el-button type="primary" @click="searchData">查询</el-button>
        </div>
      </div>
    </div>
    <div class="tuolele-main-box">
      <Table :data-info.sync="dataInfo" />
    </div>
  </div>
</template>

<script>
import Table from '@/components/statistics/teacherStatistics/Table.vue'
import Tool from '@/assets/js/tool.js'
export default {
  name: 'TeacherStatistics',
  components: {
    Table
  },
  props: [''],
  data() {
    return {
      filterObj: {
        begin_time: '',
        end_time: '',
        shop_id: '0',
        search_calendar: '',
        key:
          'G15,G16,G2,G10,G11,G12,H1,H2,H3,O1,N1,N2,N3,O3,F1,F3,A8,C13,D13,L1,M1,K3,K4,L3,M3,K1'
      },
      shopList: [],
      dataInfo: [],
      artificial_days: 0,
      natural_days: 0,
      attrArr: [
        { key: 'total_reading_num', attrs: 'G15+G16' },
        { key: 'G16', attrs: 'G16' },
        { key: 'total_child_num', attrs: 'G2+G10+G11' },
        { key: 'formal_child_num', attrs: 'G10+G11' },
        { key: 'get_school_num', attrs: 'H1+H2+H3' },
        { key: 'H1', attrs: 'H1' },
        { key: 'H2', attrs: 'H2' },
        { key: 'H3', attrs: 'H3' },
        { key: 'O1', attrs: 'O1' },
        { key: 'day_report_num', attrs: 'N1+N2+N3' },
        { key: 'O3', attrs: 'O3' },
        { key: 'N1', attrs: 'N1' },
        { key: 'N2', attrs: 'N2' },
        { key: 'N3', attrs: 'N3' },
        { key: 'F1', attrs: 'F1' },
        { key: 'F3', attrs: 'F3' },
        { key: 'A8', attrs: 'A8' },
        { key: 'C13', attrs: 'C13' },
        { key: 'D13', attrs: 'D13' },
        { key: 'refund_num', attrs: 'L1+M1' },
        { key: 'lose_num', attrs: 'K3+K4' },
        { key: 'refund_price', attrs: 'L3+M3' },
        { key: 'K1', attrs: 'K1' }
      ],
      dailyKeys: [
        'total_reading_num',
        'G16',
        'total_child_num',
        'formal_child_num',
        'get_school_num',
        'O1',
        'day_report_num',
        'O3'
      ]
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.filterObj.begin_time = Tool.formatTime(
      new Date() - 86400 * 1000 * 30,
      'date'
    )
    this.filterObj.end_time = Tool.formatTime(new Date(), 'date')
    this.getMyShopList()
    this.getDataForAccount(this.filterObj)
  },
  methods: {
    async getDataForAccount(filterObj) {
      const ret = await this.$http.getDataForAccount(filterObj)
      const me = this
      if (ret.code == 200) {
        const dataInfo = ret.data.account_data
        this.artificial_days = ret.data.artificial_days
        this.natural_days = ret.data.natural_days
        const days =
          this.filterObj.search_calendar == 1
            ? this.artificial_days
            : this.natural_days
        dataInfo.unshift({
          name: '总和',
          data: ret.data.total_data
        })
        dataInfo.forEach(e => {
          e.result = e.data
          Tool.formateData(this.attrArr, e)
          e.total_child_num = e.result.G12
            ? e.total_child_num - e.result.G12
            : e.total_child_num
          e.formal_child_num = e.result.G12
            ? e.formal_child_num - e.result.G12
            : e.formal_child_num
          e.refund_price = e.refund_price / 100
          e.D13 = e.D13 / 100
          e.F3 = e.F3 / 100
          me.dailyKeys.forEach(ele => {
            e[ele + '_daily'] = (e[ele] / days).toFixed(1) - 0
          })
          e.get_school_num_percent =
            e.total_reading_num == 0
              ? 0
              : ((e.get_school_num / e.total_reading_num) * 100).toFixed(2) - 0
          e.O1_percent =
            e.get_school_num == 0
              ? 0
              : ((e.O1 / e.get_school_num) * 100).toFixed(2) - 0
          e.day_report_num_percent =
            e.get_school_num == 0
              ? 0
              : ((e.day_report_num / e.get_school_num) * 100).toFixed(2) - 0
          e.O3_percent =
            e.day_report_num == 0
              ? 0
              : ((e.O3 / e.day_report_num) * 100).toFixed(2) - 0
          e.lose_num_percent =
            e.total_child_num == 0
              ? 0
              : (
                (((e.lose_num + e.K1) * days) / e.total_child_num) *
                  100
              ).toFixed(2) - 0
        })
        this.dataInfo = dataInfo
      }
    },
    async getMyShopList() {
      const ret = await this.$http.getMyShopList()
      if (ret.code == 200) {
        this.shopList = ret.data
      }
    },
    changeCalendar() {
      if (this.filterObj.search_calendar == 1) {
        this.filterObj.search_calendar = 0
      } else {
        this.filterObj.search_calendar = 1
      }
    },
    searchData() {
      this.getDataForAccount(this.filterObj)
    }
  }
}
</script>
<style lang="scss" scoped>
.teacher-statistics {
  .form-row {
    .form-input {
      .el-button {
        width: 90px;
        height: 40px;
        margin-left: 20px;
      }
      .calendar-btn {
        display: inline-block;
        width: 150px;
        height: 40px;
        border-radius: 6px;
        border: solid 1px #ebebeb;
        vertical-align: middle;
        margin-left: 20px;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        cursor: pointer;
        &.active {
          border-color: $color_blue;
          color: $color_blue;
        }
      }
      > i {
        font-style: normal;
        margin: 0 10px;
      }
    }
  }
}
</style>
